var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main--text mb-4"},[(_vm.data.type === 'moretyme')?_c('MoreTyme',{key:`widgetmoretyme`}):_vm._e(),(_vm.data.type === 'payflex')?_c('Payflex',{key:`widgetpayflex`}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }